import Link from "next/link";
import Icon from "../../../components/ui/AppIcon";

interface CategoryCardProps {
  category: {
    id: string;
    name: string;
    icon: string;
    count: number;
    color: string;
  };
}

const CategoryCard = ({ category }: CategoryCardProps) => {
  return (
    <Link data-component-id="src/app/homepage/components/CategoryCard.tsx:16:4" data-component-path="src/app/homepage/components/CategoryCard.tsx" data-component-line="16" data-component-end-line="36" data-component-file="CategoryCard.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22group%20bg-card%20rounded-xl%20p-6%20shadow-md%20hover%3Ashadow-warm%20transition-all%20duration-300%20transform%20hover%3Ascale-105%20border%20border-border%20hover%3Aborder-brand-primary%22%7D"
      href={`/category-listings?category=${category.id}`}
      className="group bg-card rounded-xl p-6 shadow-md hover:shadow-warm transition-all duration-300 transform hover:scale-105 border border-border hover:border-brand-primary"
    >
      <div data-component-id="src/app/homepage/components/CategoryCard.tsx:20:6" data-component-path="src/app/homepage/components/CategoryCard.tsx" data-component-line="20" data-component-end-line="29" data-component-file="CategoryCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`w-16 h-16 rounded-lg ${category.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}
      >
        <Icon data-component-id="src/app/homepage/components/CategoryCard.tsx:23:8" data-component-path="src/app/homepage/components/CategoryCard.tsx" data-component-line="23" data-component-end-line="28" data-component-file="CategoryCard.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D"
          name={category.icon as any}
          size={32}
          variant="outline"
          className="text-white"
        />
      </div>
      <h3 data-component-id="src/app/homepage/components/CategoryCard.tsx:30:6" data-component-path="src/app/homepage/components/CategoryCard.tsx" data-component-line="30" data-component-end-line="32" data-component-file="CategoryCard.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20font-semibold%20text-lg%20text-foreground%20mb-2%20group-hover%3Atext-brand-primary%20transition-colors%22%7D" className="font-headline font-semibold text-lg text-foreground mb-2 group-hover:text-brand-primary transition-colors">
        {category.name}
      </h3>
      <p data-component-id="src/app/homepage/components/CategoryCard.tsx:33:6" data-component-path="src/app/homepage/components/CategoryCard.tsx" data-component-line="33" data-component-end-line="35" data-component-file="CategoryCard.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22services%20available%22%7D" className="font-body text-sm text-muted-foreground">
        {category.count} services available
      </p>
    </Link>
  );
};

export default CategoryCard;
